import { registerAccountSagas } from './account.saga';
import { registerAccountApplicationSagas } from './accountApplication.saga';
import accountDetails from './accountDetails';
import { registerAccountHolderSagas } from './accountHolders.sagas';
import cashieringSaga from './cashiering';
import { registerCommonSagas } from './common.saga';
import configs from './configs';
import investigations from './investigations';
import { registerOfferOrderSagas } from './offerOrder.saga';
import offersSaga from './offers.sagas';
import offerWatches from './offerWatches.sagas';
import { registerOrderSagas } from './order.saga';
import { registerPositionSagas } from './position.saga';
import { registerQuoteSagas } from './quote.saga';
import registerStatementsSagas from './statements.sagas';
import user from './users.sagas';

/**
 * Register all sagas
 */
export default [
  registerCommonSagas,
  user,
  registerAccountHolderSagas,
  registerAccountSagas,
  registerAccountApplicationSagas,
  registerStatementsSagas,
  accountDetails,
  cashieringSaga,
  offersSaga,
  investigations,
  configs,
  registerOrderSagas,
  registerPositionSagas,
  registerQuoteSagas,
  registerOfferOrderSagas,
  offerWatches,
];
